import { createReducer } from '@reduxjs/toolkit';

import postLogout from '../../thunks/auth/logout';

const initialState = {
  loading: false,
  error: null,
  logout: false,
};

const logoutReducer = createReducer(initialState, {
  [postLogout.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
    logout: false
  }),
  [postLogout.fulfilled]: (state) => ({
    ...state,
    loading: false,
    logout: true
  }),
  [postLogout.rejected]: (state) => ({
    ...state,
    loading: false,
    logout: false,
    error: 'Error on logout'
  }),
});

export default logoutReducer;
